'use client';

import Link from 'next/link';
import paths from '@/paths';
import styles from './ProfileDropdown.module.css';
import { signOut, useSession } from 'next-auth/react';

export const AuthenticatedOptions = () => {
  const session = useSession();

  const isAdmin = !!session?.data?.user.isAdmin;

  const logout = async() => {
    await signOut();
  }

  if (isAdmin) {
    return (
      <div className={styles.dropdown}>
        <Link href={paths.account.bookings()} className={styles.option}>
          Bookings
        </Link>
        <Link href={paths.account.myTours()} className={styles.option}>
          My Tours
        </Link>
        <Link href={paths.account.myAgency()} className={styles.option}>
          My Agency
        </Link>
        <Link href={paths.profile()} className={styles.option}>
          Profile
        </Link>
        <div className={styles.separator}></div>
        <div className={`${styles.option} ${styles.red}`} onClick={logout}>
          Log out
        </div>
      </div>
    );
  }

  return (
    <div className={styles.dropdown}>
      <Link href={paths.profile()} className={styles.option}>
        Profile
      </Link>
      <Link href={paths.account.reservations()} className={styles.option}>
        Reservations
      </Link>
      <div className={styles.separator}></div>
      <Link href={paths.account.myAgency()} className={styles.option}>
        List your tour
      </Link>
      <div className={styles.separator}></div>
      <div className={`${styles.option} ${styles.red}`} onClick={logout}>
        Log out
      </div>
    </div>
  );
};
